module.exports = __webpack_public_path__ + "b39117f9a1258391c3aeb985a61ae24f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/taggy_icon.png
 ** module id = 902
 ** module chunks = 9
 **/